import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Watermark from "helpers/Watermark.js";
import { HeaderStyles, ContainerStyles, HeadingStyles, TextStyles } from "styles/style";
import { api } from "supabase/database/api.ts";
import { TextContent, PdfContent, QnAContent, VideoContent, AudioContent } from "components/content";
import { utils } from "supabase/content/utils.ts";

export default function ContentDetail({
  table = null,
  title = null
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);

  useEffect(() => {
    async function prepMaterial() {
      let data;
      try {
        if (id?.length === 6) {
          data = await api.contentQueries.getContent({ table: table, date: utils.formatDate(id) });
        } else {
          data = await api.contentQueries.getContent({ table: table, id: id });
        }

        if (!data || (Array.isArray(data) && data.length === 0)) {
          // content not found → redirect to parent
          const segments = window.location.pathname.split("/").filter(Boolean);
          segments.pop(); // remove current slug/id
          while (segments.length > 0) {
            const parentPath = "/" + segments.join("/");
            navigate(parentPath, { replace: true });
            return;
          }
          // fallback to home
          navigate("/home", { replace: true });
          return;
        }

        setContent(data);
      } catch (err) {
        console.error(err);
        // On error, redirect to parent/home
        const segments = window.location.pathname.split("/").filter(Boolean);
        segments.pop();
        while (segments.length > 0) {
          const parentPath = "/" + segments.join("/");
          navigate(parentPath, { replace: true });
          return;
        }
        navigate("/home", { replace: true });
      }
    }

    prepMaterial();
  }, [table, id, navigate]);

  if (!content) return null;

  return (
    <AnimationRevealPage>
      <HeaderStyles.ContentStyledHeader />
      <ContainerStyles.Container>
        <ContainerStyles.ContentWithPaddingXl>
          <HeadingStyles.HeadingRow>
            <HeadingStyles.Heading>
              <TextStyles.HighlightedText>
                {table === "scj-spop" || table === "scj-hymns" ? "Shincheonji Music" : content?.title || title }
              </TextStyles.HighlightedText>
            </HeadingStyles.Heading>
          </HeadingStyles.HeadingRow>
          <Watermark />

          {/* Determine type of content and render accordingly based on content */}
          { content?.video_key?.length > 0 && <VideoContent vid_key={content?.video_key} /> }
          { content?.audio?.length > 0 && <AudioContent audio={content} title={title} /> }
          { content?.file?.length > 0 && <PdfContent file={content?.file} contents={content?.table_of_contents} /> }
          { content?.content?.length > 0 && <TextContent content={content?.content} /> }
          { content?.length > 0 && content[0]?.question && content[0]?.answer && <QnAContent faqs={content} /> }

        </ContainerStyles.ContentWithPaddingXl>
      </ContainerStyles.Container>
    </AnimationRevealPage>
  );
}
